window.__APP_CONFIG__ = {
	apiBaseUrl: process.env.VITE_API_URL ?? '',
};